<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    width?: string | number;
    height?: string | number;
    viewBox?: string;
    color?: string;
  }>(),
  {
    width: '40',
    height: '37',
    viewBox: '0 0 40 37',
    color: '#A3A3A3',
  }
);
</script>

<template>
  <svg
    :width="props.width"
    :height="props.height"
    :viewBox="props.viewBox"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.3333 12.1C18.3333 12.9837 17.5871 13.7 16.6666 13.7C15.7462 13.7 15 12.9837 15 12.1C15 11.2163 15.7462 10.5 16.6666 10.5C17.5871 10.5 18.3333 11.2163 18.3333 12.1ZM18.3333 24.9C18.3333 25.7837 17.5871 26.5 16.6666 26.5C15.7462 26.5 15 25.7837 15 24.9C15 24.0163 15.7462 23.3 16.6666 23.3C17.5871 23.3 18.3333 24.0163 18.3333 24.9ZM23.3334 13.7C24.2539 13.7 25.0001 12.9837 25.0001 12.1C25.0001 11.2163 24.2539 10.5 23.3334 10.5C22.413 10.5 21.6668 11.2163 21.6668 12.1C21.6668 12.9837 22.413 13.7 23.3334 13.7ZM25 24.9C25 25.7837 24.2538 26.5 23.3334 26.5C22.4129 26.5 21.6667 25.7837 21.6667 24.9C21.6667 24.0163 22.4129 23.3 23.3334 23.3C24.2538 23.3 25 24.0163 25 24.9ZM23.3334 20.1C24.2538 20.1 25 19.3837 25 18.5C25 17.6164 24.2538 16.9 23.3334 16.9C22.4129 16.9 21.6667 17.6164 21.6667 18.5C21.6667 19.3837 22.4129 20.1 23.3334 20.1ZM18.3333 18.5C18.3333 19.3837 17.5871 20.1 16.6666 20.1C15.7462 20.1 15 19.3837 15 18.5C15 17.6164 15.7462 16.9 16.6666 16.9C17.5871 16.9 18.3333 17.6164 18.3333 18.5Z"
      :fill="props.color"
    />
  </svg>
</template>

<style scoped>
svg {
  display: inline-block;
  vertical-align: middle;
}
</style>
